import * as yup from 'yup';
import * as Schema from '../schemaFields';

export const coordinatesValidationSchema = yup.object({
  coordinates: Schema.coordinatesString,
});
